<template>
    <div>
        <h1>上传新的智能项圈固件</h1>

        <!-- 二维码需要的信息表单 -->
        <el-form ref="bc_form" :model="form" :inline="false" :rules="rules" label-position="left" label-width="120px"
                style="width:70%; margin-left:0%">
            <el-form-item label="硬件版本号" prop="hwver">
                <el-input-number v-model="form.hwver" :min="10" :max="255" label="硬件版本号10-255" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="固件版本号" prop="fwver">
                <el-input-number v-model="form.fwver" :min="10" :max="255" label="固件版本号10-255" :precision="0"></el-input-number>
            </el-form-item>
            <el-form-item label="升级说明" prop="desc">
                <el-input type="textarea" v-model="form.desc" clearable size="mini" style="width:90%" placeholder="升级版本的说明注释信息"></el-input>
            </el-form-item>
            <el-form-item label="强制更新">
                <el-switch v-model="form.force"></el-switch>
            </el-form-item>
            <el-form-item label="选择固件文件" prop="upload">
                <el-upload class="upload-demo" ref="upload" :accept="acceptFile()" action="" :http-request="httpRequest" :auto-upload="false"
                    :on-change="fileChange" :on-remove="fileRemove" :file-list="fileList">
                    <el-button size="small" type="primary">选择文件</el-button>
                    <div slot="tip" class="el-upload__tip">只能上传hex文件</div>
                </el-upload>
            </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer">
            <el-button @click="submit" type="primary">上传固件</el-button>
        </span>
    </div>

    <!--el-form ref="importList" :rules="ImportRules" :model="importList" label-position="left" label-width="100px" 
        style="width:70%;margin-left:50px;">
        <el-form-item label="平台号：" prop="platNum">
            <el-input v-model="importList.platNum" clearable maxlength="50" placeholder="请输入平台号" size="mini"  style="width: 90%"/>
        </el-form-item>
        <el-form-item label="任务名称：" prop="taskName">
            <el-input v-model="importList.taskName" clearable maxlength="50" placeholder="请输入任务名称" size="mini"  style="width: 90%"/>
        </el-form-item>
        <el-form-item label="Excel文件：" prop="file">
            <el-upload class="upload-demo" ref="upload" multipleaccept=".xls" action="" :with-credentials="true"
                :http-request="httpRequest" :on-preview="handlePreview" :on-remove="handleRemove" :on-change="fileChange"
                :on-success="upFile" :file-list="fileList" :data="getUploadList" :auto-upload="false">
                <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
                <div slot="tip" class="el-upload__tip" style="display: inline-block;margin-left: 20px">只能上传xls格式的 excel文件</div>
            </el-upload>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button @click="cancelFinishPlatform">取消</el-button>
        <el-button style="margin-left: 10px;" type="success" @click="submitUploadList">上传到服务器</el-button>
    </div>
    httpRequest(param) {
        console.log(param)
        let fileObj = param.file 
        let fd = new FormData()  
        fd.append('file', fileObj) 
        fd.append('platNum', this.importList.platNum)  
        fd.append('taskName', this.importList.taskName)
        let url = process.env.CMS1_BASE_API + 'cdnDel/uploadExcel'let 
        config = {headers: {'Content-Type': 'multipart/form-data'    }  }  
        axios.post(url, fd, config).then(res=>{if(res.code===0){this.submitForm();   }  })}
    -->
</template>

<script>

import {uploadBeltFW} from "../api"

export default {
    data() {
        var validateFileUrl = (rules, value, callback) => {
            if(this.fileList.length < 1) {
                callback(new Error("请选择文件"));
            } else {
                callback();
            }
        } 
        return {
            form: {
                hwver: 10,
                fwver: 10,
                desc: "",
                force: false
            },

            rules: {
                hwver: [
                    { required: true, message: '硬件版本号10-255' }
                ],
                fwver: [
                    { required: true, message: '固件版本号10-255' }
                ],
                desc: [
                    { required: true, message: '请填写描述信息' }
                ],
                upload: [
                    { required: true, validator: validateFileUrl, message: '请选择上传文件' }
                ]
            },
            
            fileList: []
        };
    },
    methods: {
        submit() {
            this.$refs.bc_form.validate((valid) => {
                console.log(valid);
                console.log("Filelist = ", this.fileList)
                if (valid) {
                    this.$refs.upload.submit();
                }
            })
        },

        open2() {
            this.$message({
                message: '上传成功',
                type: 'success'
            });
        },

        open4(errStr) {
            this.$message.error('上传失败:' + errStr);
        },

        httpRequest(param) {
            console.log(param)
            var fileObj = param.file 
            console.log("httpRequest: ", fileObj)
            var fd = new FormData()  
            fd.append('hardware_version', this.form.hwver)
            fd.append('firmware_version', this.form.fwver)
            fd.append('firmware_url', fileObj)
            fd.append('description', this.form.desc)
            fd.append('is_force_update', +this.form.force)
            //var config = {headers: {'Content-Type': 'multipart/form-data'} }  
            var config = {headers: {} }  

            var that = this;
            uploadBeltFW(fd, config).then(res => {
                console.log("uploadBeltFW res: ", res);
                if(res.data.code === 200) {
                    that.open2();
                }
                else {
                    that.open4(res.data.data.err_msg + "[" + res.data.code + "]");
                }
            });
            //axios.post(url, fd, config).then(res=>{if(res.code===0){this.submitForm();   
        },

        fileChange(file, fileList) {
            this.fileList = [file];
            console.log("fileChange: ", file, this.fileList);
        },

        fileRemove(file, fileList) {
            this.fileList = [];
            console.log("fileRemove: ", file, this.fileList);
        },
        
        acceptFile() {
            return ".hex"
        }
    }
}
</script>